/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WisdomBanner from '@components/HeaderBanner/WisdomBanner';
import Breadcrum from '@components/Navigation/Breadcrum';
import AllTopics from '@components/UI/AllTopics';
import HeadComponent from '@components/Utility/HeadComponent';
import { getLocale } from '@components/Utility/Shared/SharedService';
import config from '@config';
import { AuthContext } from '@store/auth-context';

/* Services */
import {
  fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
/* Services */
import {
  fetchAllTopicsList, fetchWisdomLandingPageData, getWisdomLandingPaths
} from 'services/wisdomService';

/**
 * Renders the Topics List
 *
 * @function
 * @param {string} region - Current User Region.
 * @param {string} language - Current User Language.
 * @param {string} wisdomTopics - Topics List.
 * @param {string} pageData - Meta Data needed for this page.
 * @returns {ReactElement} Wisdom Landing Page.
 */
export default function TopicsList({
  region,
  language,
  wisdomTopics,
  pageData,
}) {
  const authContext = useContext(AuthContext);
  // const [currentUserRegion, setCurrentUserRegion] = useState(region);
  useEffect(() => {
    // const currentRegion = config.locales.find(
    //   locale => locale.region_sf === region
    // ).region;
    authContext.RegionAndLang(region, language);
    // setCurrentUserRegion(currentRegion);
  }, [region]);

  return pageData ? (
    <Box pos="relative" float="left" w="100%">
      <HeadComponent
        data={pageData._seoMetaTags}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Box>
        <Breadcrum
          // As data is not coming, we explicitly add Topics Breadcrumb
          page={pageData?.breadcrumbs}
          alsoin={pageData?.alsoin}
          url={pageData?.url}
          region={region}
          lang={language}
          pageConfig={pageData?.pageConfig}
        />
      </Box>
      {/* wisdom banner section */}
      <Box
        marginTop={{ base: '12px', sm: '12px', md: '0', lg: '0' }}
        pos="relative"
        float="left"
        w="100%"
      >
        <WisdomBanner title="Topics" />
      </Box>
      <Box
        pos="relative"
        float="left"
        w="100%"
        display="flex"
        justifyContent="center"
      >
        <AllTopics topics={wisdomTopics} />
      </Box>
    </Box>
  ) : (
    ''
  );
}

export const getStaticPaths = async () => {
  const wisdomLandingPaths = config.USE_LOCAL_URL
    ? ['/en/wisdom/topics']
    : await getWisdomLandingPaths('L1', '/wisdom/topics');
  return {
    paths: wisdomLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region },
  req,
}) => {
  const language = region;
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  const pageData = await fetchWisdomLandingPageData({
    region: '',
    lang: language,
    preview,
    data: previewData,
    slug: `wisdom/topics`,
    localeURL: `/topics`,
    previewData: { preview, data: previewData }
  });
  const topics = await fetchAllTopicsList('', language);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language: language,
      footerData: footerData?.data,
      pageData: pageData || null,
      wisdomTopics: topics?.topics || null,
      page: 'topics',
      isPreview: preview ? true : false
    }
  };
};
